import { simpleLookupConfig } from "../../../shared/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineBankConfig";

const url = "/api/machines/MachineBankConfig";

export const machineBankConfigLookupConfig = simpleLookupConfig({
  name: vsObjectName,
  nameSingular: "Bank Config",
  url,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
});
